import type { ReactNode } from "react";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

export function DashboardInfoSheet({ title, description, children }: { title: string; description: string; children: ReactNode }) {
  return <Sheet>
    <SheetTrigger asChild><Button variant="ghost" size="icon" className="h-7 w-7 shrink-0 text-muted-foreground" aria-label={`${title} details`} title={`${title} details`}><Info className="h-4 w-4" /></Button></SheetTrigger>
    <SheetContent className="w-full overflow-y-auto sm:max-w-2xl">
      <SheetHeader className="pr-6"><SheetTitle>{title}</SheetTitle>
      {/* <SheetDescription>{description}</SheetDescription> */}
      </SheetHeader>
      <div className="mt-6">{children}</div>
    </SheetContent>
  </Sheet>;
}